import { Icon } from '@design-system';
import { FavoriteRef } from '@services';
import { AiFillIdcard } from 'react-icons/ai';
import { BiSolidBarChartAlt2, BiSolidChat } from 'react-icons/bi';
import { BsClipboard2CheckFill, BsPersonFillExclamation } from 'react-icons/bs';
import { FaShoppingBasket, FaUmbrellaBeach } from 'react-icons/fa';
import { FaTriangleExclamation } from 'react-icons/fa6';
import { HiClipboardDocumentList, HiMiniDocumentMagnifyingGlass } from 'react-icons/hi2';
import { IoBagHandleSharp, IoLibrary, IoShieldCheckmarkSharp } from 'react-icons/io5';
import { MdTimer } from 'react-icons/md';
import { PiMedalFill } from 'react-icons/pi';

type ComputedFavorite = {
    label: string;
    icon: React.ReactNode;
    color: string;
    link: string;
};

export const rawFavorites: Record<FavoriteRef, ComputedFavorite> = {
    'mc/appro': {
        color: 'red',
        icon: <Icon icon={<IoBagHandleSharp />} size={20} />,
        label: "Demande d'approvisionnement",
        link: '/mes-chantiers/approvisionnement'
    },
    'mc/quitus': {
        color: 'red',
        icon: <Icon icon={<BsClipboard2CheckFill />} size={20} />,
        label: 'Levée de réserve et quitus',
        link: '/mes-chantiers/quitus'
    },
    'mc/aqc': {
        color: 'red',
        icon: <Icon icon={<FaShoppingBasket />} size={20} />,
        label: 'Essai / AQC ',
        link: '/mes-chantiers/testsheets'
    },
    'mc/results': {
        color: 'red',
        icon: <Icon icon={<BiSolidBarChartAlt2 />} size={20} />,
        label: 'Mes résultats de chantier',
        link: '/mes-chantiers/my-worksite-results'
    },
    'mc/events': {
        color: 'red',
        icon: <Icon icon={<FaTriangleExclamation />} size={20} />,
        label: "Remontée d'évènement",
        link: '/mes-chantiers/event-feedback'
    },
    'mc/mc': {
        color: 'red',
        icon: <Icon icon={<IoBagHandleSharp />} size={20} />,
        label: 'Mes chantiers',
        link: ''
    },
    'sst/homesecurity': {
        color: 'blue',
        icon: <Icon icon={<IoShieldCheckmarkSharp />} size={20} />,
        label: 'Accueil sécurité',
        link: '/sante-securite/home-security'
    },
    'sst/events': {
        color: 'blue',
        icon: <Icon icon={<FaTriangleExclamation />} size={20} />,
        label: "Remontée d'évènement",
        link: '/sante-securite/event-feedback'
    },
    'sst/talks': {
        color: 'blue',
        icon: <Icon icon={<BiSolidChat />} size={20} />,
        label: 'Causeries',
        link: '/sante-securite/causeries/list'
    },
    'sst/audits': {
        color: 'blue',
        icon: <Icon icon={<HiMiniDocumentMagnifyingGlass />} size={20} />,
        label: 'Visite de sécurité',
        link: '/sante-securite/security-audit'
    },
    'sst/ppsps': {
        color: 'blue',
        icon: <Icon icon={<HiClipboardDocumentList />} size={20} />,
        label: 'PPSPS',
        link: '/sante-securite/ppsps'
    },
    'sst/rules': {
        color: 'blue',
        icon: <Icon icon={<PiMedalFill />} size={20} />,
        label: "Règles d'or",
        link: '/sante-securite/golden-rules'
    },
    'sst/epis': {
        color: 'blue',
        icon: <Icon icon={<IoBagHandleSharp />} size={20} />,
        label: "Demande d'EPI",
        link: '/sante-securite/epi'
    },
    'sst/library': {
        color: 'blue',
        icon: <Icon icon={<IoLibrary />} size={20} />,
        label: 'Bibliothèque sécurité',
        link: '/sante-securite/bibliotheque'
    },
    'sst/quiz': {
        color: 'blue',
        icon: <Icon icon={<IoShieldCheckmarkSharp />} size={20} />,
        label: 'Module de formation',
        link: ''
    },
    'rh/pointage': {
        color: 'yellow',
        icon: <Icon icon={<MdTimer />} size={20} />,
        label: 'Pointage',
        link: '/richesses-humaines/pointage'
    },
    'rh/holidays': {
        color: 'yellow',
        icon: <Icon icon={<FaUmbrellaBeach />} size={20} />,
        label: "Demandes d'absence",
        link: '/richesses-humaines/conges'
    },
    'rh/library': {
        color: 'yellow',
        icon: <Icon icon={<IoLibrary />} size={20} />,
        label: 'Bibliothèque RH',
        link: '/richesses-humaines/bibliotheque'
    },
    'rh/btp': {
        color: 'yellow',
        icon: <Icon icon={<AiFillIdcard />} size={20} />,
        label: 'Carte BTP',
        link: '/richesses-humaines/carte-btp'
    },
    'rh/events': {
        color: 'yellow',
        icon: <Icon icon={<BsPersonFillExclamation />} size={20} />,
        label: 'Remontées RH',
        link: '/richesses-humaines/event-feedback'
    }
};

export const mapRefToFavorite = (reference: FavoriteRef): ComputedFavorite => rawFavorites[reference];
